import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { SettingsStarMicronicsReceiptPrinterPage } from 'src/app/modals/settings-star-micronics-receipt-printer/settings-star-micronics-receipt-printer.page';

const routes: Routes = [
  {
    path: '',
        component: SettingsStarMicronicsReceiptPrinterPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
    declarations: [SettingsStarMicronicsReceiptPrinterPage]
})
export class SettingsStarMicronicsReceiptPrinterPageModule {}
